module.exports = __webpack_public_path__ + "static/media/thumbnail.e2b89711.jpg";